import { render, staticRenderFns } from "./quickLinksCarousal.vue?vue&type=template&id=652a257c"
import script from "./quickLinksCarousal.vue?vue&type=script&lang=js"
export * from "./quickLinksCarousal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports